// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenu-cls1___25f8faa9ed69a5fb900{/*!*/}.AccountMenu-cls2__b6df1b2d73da4e715d89{width:24px;width:var(--spacing-sm-24, 24px);height:24px;height:var(--spacing-sm-24, 24px);border-radius:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenu-cls1___25f8faa9ed69a5fb900",
	"cls2": "AccountMenu-cls2__b6df1b2d73da4e715d89 AccountMenu-cls1___25f8faa9ed69a5fb900"
};
export default ___CSS_LOADER_EXPORT___;
